import { IconButton, styled } from '@mui/material';

export const StyledGoalItemFormCheckBoxWrap = styled('div')({
	display: 'flex',
	alignItems: 'flex-start',

	'&:hover': {
		'& button': {
			opacity: 1,
			visibility: 'visible',
			width: 'auto',
		},
	},
});

export const StyledGoalItemFormCheckBoxCloseButton = styled(IconButton)(({ theme }) => ({
	padding: '0',
	color: theme.palette.error.contrastText,
	visibility: 'hidden',
	opacity: 0,
	width: 0,
	overflow: 'hidden',
	transition: 'width 0s 0s, opacity 0.3s 0s linear',
}));
